<template>
  <v-container
    class="talktrend-base ma-0 pa-0"
    fluid
  >
    <div v-if="showAlert">
      <v-alert
        class="v-alert alert_overlay"
        v-model="showAlert"
        border="left"
        close-text="Close Alert"
        dismissible
        :type="alertType"
      >
        {{ alertMsg }}
      </v-alert>
    </div>
    <v-row class="talktrend-base__content ma-0 pa-0">
      <v-col cols="12" class="talktrend-base__content ma-0 pa-0">
        <v-row class="talktrend-base__header ma-0 px-6 pt-4 pb-2">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row width="100%" class="talktrend-base__title-row ma-0 pa-0" align="center">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img :src="main_logo" max-height="48px" max-width="80px" contain></v-img>
              </v-col>
              <v-col cols="auto" class="ma-0 pa-0">
                <span class="page-title">Talk Trend</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col v-if="audience_tab=='overview'" sm="9" md="8" lg="8" class="ma-0 pa-0">
                <v-row class="talktrend-base__content ma-0 pa-0">
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="ma-0 mr-1 pa-0">
                    <PerformanceMainStatistic statistic_title_name="Dedup Pop." :value="rch_highlight" :value_format="'abs'"/>
                  </v-col>
                  <v-col cols="auto" class="ma-0 mr-1 pa-0">
                    <PerformanceMainStatistic statistic_title_name="WSI Avg" :value="wom_highlight"/>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row width="100%" class="ma-0 pa-0">
              <v-tabs v-model="audience_tab" align-tabs="start" light>
                <v-tab class="tool-navigation-bar" href="#saved">My Audiences</v-tab>
                <v-tab :disabled="audience_tab == 'saved'" class="tool-navigation-bar" href="#overview">Audience Overview</v-tab>
              </v-tabs>
            </v-row>
          </v-col>
        </v-row>
        <v-col cols="12" v-if="page_loading">
          <v-row class="talktrend-base__content ma-0 pa-0" align="center" justify="center">
              <v-col cols="auto">
                  <v-progress-circular color="black" size="100" indeterminate></v-progress-circular>
              </v-col>
          </v-row>
        </v-col>
        <v-tabs-items
          class="tab-content ma-0 pa-0"
          v-model="audience_tab"
          v-else
        >
          <v-tab-item
            class="tab-item"
            value="saved"
          >
            <div class="tab-panel-content ma-0 pa-0">
              <TalkTrendSaved
                v-on:triggerAlert="triggerAlert"
                v-on:open_audience="open_report"
                :audiences="available_audiences"
              >
              </TalkTrendSaved>
            </div>
          </v-tab-item>
          <v-tab-item
            class="tab-item tab-item--scrollable"
            value="overview"
          >
            <v-row width="100%" class="talktrend-base__overview-content ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <div class="talktrend-base__inner-tab-content ma-0 pa-0">
                  <TalkTrendStatsBasePage
                    :audiences="available_audiences"
                    :audience_info="viewing_audience_info"
                    :audience_data="viewing_audience_data"
                    :audience_data_graph="viewing_audience_data"
                    :selected_slider_id="selected_slider_id"
                    v-on:sliderOnChange="slider_on_change"
                    v-on:viewing_audience="update_viewing_audience">
                  </TalkTrendStatsBasePage>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
  import logo from "@/assets/TalkTrendLogo.png";
  import TalkTrendSaved from "./TalkTrendPages/TalkTrendSaved.vue";
  import TalkTrendStatsBasePage from "./TalkTrendPages/TalkTrendStatsBasePage.vue";
  import PerformanceMainStatistic from "@/components/Performance/PerformanceStats/PerformanceReportSections/PerformanceMainStatistic.vue";
  import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE } from "@/constants/constants";
  import audience_api_caller from "@/javascript/audience.js";

  export default {
    name: "TalkTrendBasePage",
    components: {
      TalkTrendSaved,
      PerformanceMainStatistic,
      TalkTrendStatsBasePage
    },
    async mounted(){
    },
    beforeDestroy() {
      clearTimeout(this.alertTimeout);
    },
    watch: {
    },
    data: () => ({
      page_loading: false,
      alertMsg: null,
      alertType: null,
      showAlert: false,
      alertTimeout: null,
      main_logo: logo,
      audience_tab: "saved",
      selected_slider_id: null,

      rch_highlight: null,
      wom_highlight: null,
      frq_highlight: null,
      imp_highlight: null,

      available_audiences: [],

      viewing_audience_info: {},
      viewing_graph_index: 0,
      viewing_audience_data: {},
    }),
    methods: {
      triggerAlert: function (type, message) {
        this.alertType = type ? type : "info";
        this.alertMsg = message;
        this.showAlert = true;
        clearTimeout(this.alertTimeout);
        this.alertTimeout = setTimeout(() => {
          this.showAlert = false;
          this.alertTimeout = null;
        }, 5000);
      },

      get_audience_stats: async function (audience_id) {
          this.page_loading = true;
          let payload = {
              project_id: this.$project.get_val(),
              audience_id: audience_id
          };

          let token = await this.$auth.getTokenSilently();
          
          let result = await audience_api_caller.fetch_audience_stats(token, payload)
              .then((resp) => {
                  if (resp["success"]) {
                      return resp["data"];
                  }
                  return false;
              })
              .catch(() => {
                  return false;
              });
          if (result && result["audience_stats"]) {
              this.viewing_audience_data = result["audience_stats"]
          } else {
              this.triggerAlert(ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
          }

          this.page_loading = false;
      },

      open_report: async function (audience_id) {
        this.selected_slider_id = null;
        await this.get_audience_stats(audience_id)
        this.update_viewing_audience(audience_id);
        this.audience_tab = 'overview';
      },
      slider_on_change: function(slider_id) {
        this.selected_slider_id = slider_id;
        this.set_highlights(this.viewing_audience_data['audience_highlights'][slider_id])
      },

      set_highlights: function (highlights){
        this.rch_highlight = Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(highlights['population']);
        this.wom_highlight = highlights['wom'].toFixed(2).toString();
      },
      update_viewing_audience: function(audience_id){
        let viewing_aud = {};
        for(let aud of this.available_audiences){
          if(aud.audience_id == audience_id){
            viewing_aud = aud;
            break;
          }
        }
        this.viewing_audience_info = viewing_aud;
        this.rch_highlight = this.viewing_audience_data["audience_highlights"][this.viewing_graph_index]["population"];
        this.frq_highlight = this.viewing_audience_data["audience_highlights"][this.viewing_graph_index]["wsi"];
      }
    },
  };
  </script>
  
  <style scoped>
  .talktrend-base {
    height: calc(100vh - 96px);
    max-height: calc(100vh - 96px);
    overflow-y: hidden;
    width: 100%;
  }

  .talktrend-base__content {
    height: 100%;
    width: 100%;
  }

  .talktrend-base__header {
    min-height: 10%;
  }

  .talktrend-base__title-row {
    min-height: 60px;
  }

  .talktrend-base__overview-content {
    min-height: 10%;
  }

  .page-title {
    font-family: "Poppins" !important;
    font-weight: 800;
    font-size: 2em;
  }

  .tab-item {
    height: 100%;
    max-height: 100%;
    width: 100%;
  }

  .tab-item--scrollable {
    overflow-y: auto;
  }

  .tab-content {
    height: calc(100vh - 230px);
    max-height: calc(100vh - 230px);
    width: 100%;
  }

  .talktrend-base__inner-tab-content {
    height: 100%;
    max-height: 100%;
    width: 100%;
  }

  .tab-panel-content {
    height: 100%;
    width: 100%;
  }

  .tool-navigation-bar {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 0.9em !important;
  }
  
  /deep/.v-window__container {
    height: 100% !important;
  }

  .v-alert {
    position: fixed;
    left: 50%;
    width: 100%;
    transform: translate(-50%, 0%);
    z-index: 2;
  }
  .alert_overlay {
    position: absolute;
    width: 100%;
    z-index: 99;
  }
  </style>
